import { Controller } from "stimulus";

export default class extends Controller {
  static values = { enabled: String, disabled: String };

  reflect() {
    this.dispatch(this.eventName, { detail: { value: this.dispatchValue }, prefix: false });
  }

  get eventName() {
    return `reflect-${this.element.id}`;
  }

  get dispatchValue() {
    return this.element.checked ? this.enabledValue : this.disabledValue;
  }
}
